/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnGnbUploadRequest model module.
 * @module model/SystemControllerDtoMnGnbUploadRequest
 * @version 1.0
 */
class SystemControllerDtoMnGnbUploadRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnGnbUploadRequest</code>.
     * @alias module:model/SystemControllerDtoMnGnbUploadRequest
     * @param gnbName {String} 
     */
    constructor(gnbName) { 
        
        SystemControllerDtoMnGnbUploadRequest.initialize(this, gnbName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, gnbName) { 
        obj['gnbName'] = gnbName;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnGnbUploadRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnGnbUploadRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnGnbUploadRequest} The populated <code>SystemControllerDtoMnGnbUploadRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnGnbUploadRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('gnbName')) {
                obj['gnbName'] = ApiClient.convertToType(data['gnbName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('icon')) {
                obj['icon'] = ApiClient.convertToType(data['icon'], 'String');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnGnbUploadRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnGnbUploadRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnGnbUploadRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['gnbName'] && !(typeof data['gnbName'] === 'string' || data['gnbName'] instanceof String)) {
            throw new Error("Expected the field `gnbName` to be a primitive type in the JSON string but got " + data['gnbName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['icon'] && !(typeof data['icon'] === 'string' || data['icon'] instanceof String)) {
            throw new Error("Expected the field `icon` to be a primitive type in the JSON string but got " + data['icon']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}

SystemControllerDtoMnGnbUploadRequest.RequiredProperties = ["gnbName"];

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnGnbUploadRequest.prototype['gnbNo'] = undefined;

/**
 * @member {String} gnbName
 */
SystemControllerDtoMnGnbUploadRequest.prototype['gnbName'] = undefined;

/**
 * @member {String} pageUrl
 */
SystemControllerDtoMnGnbUploadRequest.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
SystemControllerDtoMnGnbUploadRequest.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
SystemControllerDtoMnGnbUploadRequest.prototype['enabled'] = undefined;

/**
 * @member {String} icon
 */
SystemControllerDtoMnGnbUploadRequest.prototype['icon'] = undefined;

/**
 * @member {String} key
 */
SystemControllerDtoMnGnbUploadRequest.prototype['key'] = undefined;






export default SystemControllerDtoMnGnbUploadRequest;

